// Generated by GitHub Copilot
// US1812367: Simplified ImpactRecordCard - removed deprecated fields display
// US1879481: Moderation system removed - all impacts are auto-accepted
import React from "react";
import {
  Card,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { formatTimeAgo } from "../../utils/dateHelpers";
import { getStatusColor } from "../../constants/impactConstants";
import styles from "./ImpactRecordCard.module.css";

const ImpactRecordCard = ({
  impact,
  onEdit,
  onDelete,
  currentUserEmail,
}) => {
  const statusColors = getStatusColor(impact.status);
  const isOwnImpact = currentUserEmail && impact.createdBy === currentUserEmail;

  return (
    <Card className={`${styles.impactCard} ${styles[impact.status]} ${isOwnImpact ? styles.myImpact : ''}`}>
      <Card.Body>
        {/* Generated by GitHub Copilot - US1812367: Header Row - Status and Moderation Status badges (Priority removed) */}
        <Row className="mb-2">
          <Col xs={12}>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                className={styles.statusBadge}
                style={{
                  backgroundColor: statusColors.bg,
                  color: statusColors.text,
                }}
              >
                {impact.status.charAt(0).toUpperCase() + impact.status.slice(1)}
              </span>
            </div>
          </Col>
        </Row>

        {/* Application Name Row */}
        <Row className="mb-2">
          <Col>
            <h5
              className={styles.applicationName}
              data-testid="impact-record-heading"
            >
              {impact.applicationName}
            </h5>
          </Col>
        </Row>

        {/* Brand */}
        <Row className="mb-2">
          <Col>
            <small className={styles.brand}>
              <strong>Brand:</strong> {impact.brand}
            </small>
          </Col>
        </Row>

        {/* Generated by GitHub Copilot - CI (Configuration Item) */}
        {impact.ci && (
          <Row className="mb-2">
            <Col>
              <small className={styles.brand}>
                <strong>CI:</strong> {impact.ci}
              </small>
            </Col>
          </Row>
        )}

        {/* Generated by GitHub Copilot - Child Incident Number */}
        {impact.childIncidentNumber && (
          <Row className="mb-2">
            <Col>
              <small className={styles.brand}>
                <strong>Service Now Incident:</strong>{" "}
                {impact.childIncidentNumber}
              </small>
            </Col>
          </Row>
        )}

        {/* Impact Description */}
        <Row className="mb-3">
          <Col>
            <p className={styles.description}>{impact.impactDescription}</p>
          </Col>
        </Row>

        {/* Generated by GitHub Copilot - US1812367: Simplified Footer Info (Technical Lead removed) */}
        <Row className={styles.footer}>
          <Col xs={12} className="text-md-end">
            <small className={styles.timestamp}>
              Created {formatTimeAgo(impact.createdAt)}
              {impact.createdBy && ` by ${impact.createdBy.split("@")[0]}`}
            </small>
          </Col>
        </Row>

        {/* Generated by GitHub Copilot - Action buttons */}
        {(onEdit || onDelete) && (
          <Row className="mt-3 pt-3" style={{ borderTop: "1px solid #e5e7eb" }}>
            <Col className="text-end">
              <ButtonGroup size="sm">
                {onEdit && (
                  <Button
                    variant="outline-primary"
                    onClick={() => onEdit(impact)}
                    title="Edit impact"
                  >
                    <FaEdit className="me-1" />
                    Edit
                  </Button>
                )}{" "}
                &nbsp;
                {onDelete && (
                  <Button
                    variant="outline-danger"
                    onClick={() => onDelete(impact)}
                    title="Delete impact"
                  >
                    <FaTrash className="me-1" />
                    Delete
                  </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default ImpactRecordCard;
